import i18n from 'i18n';

type HTTPMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE' | 'OPTIONS';
type BaseFetcherOptions = {
  method?: HTTPMethod;
  headers?: Record<string, string>;
  removeHeaders?: string[];
  data?: any;
};
export class FetcherError extends Error {
  status: number;

  data: Record<string, unknown>;

  constructor(
    message: string,
    status: number,
    fieldErrors?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'Fetcher Error';
    this.status = status;
    this.data = fieldErrors;
  }
}

export default async function baseFetcher(
  url: string,
  {
    method = 'GET',
    headers = {},
    removeHeaders = [],
    data,
  }: BaseFetcherOptions = {}
) {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': i18n.language,
  };

  const authorization = localStorage.getItem('authorization');
  const authHeaders = authorization
    ? { Authorization: `Token ${JSON.parse(authorization).token}` }
    : {};
  const finalHeaders = Object.fromEntries(
    Object.entries({
      ...authHeaders,
      ...defaultHeaders,
      ...headers,
    }).filter(([header]) => !removeHeaders.includes(header))
  );
  const body =
    'Content-Type' in finalHeaders &&
    finalHeaders['Content-Type'] === 'application/json'
      ? JSON.stringify(data)
      : data;

  const response = await fetch(`${import.meta.env.REACT_APP_API_URL}${url}`, {
    method,
    headers: finalHeaders,
    body,
  });

  if (!response.ok) {
    // Parse JSON error response to get custom error message
    const errorText = await response.text();
    let errorData;
    try {
      errorData = JSON.parse(errorText);
    } catch {
      errorData = errorText;
    }
    throw new FetcherError(
      errorData.error || response.statusText,
      response.status,
      errorData
    );
  }

  if (response.status === 204) return null;

  if (response.headers.get('Content-Type') === 'application/json')
    return response.json();

  return response.blob();
}
